import { Badge, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTableTranslation } from '@hero/molecules';

import * as S from './style';

function SecondHead({ globalFilters, onFilterChange }) {
  const translation = useTableTranslation();
  const { t } = useTranslation();

  const hasAnyFilter =
    !!globalFilters?.filters?.status?.length ||
    !!globalFilters?.filters?.createdBy?.length ||
    !!globalFilters?.filters?.type?.length;

  return (
    hasAnyFilter && (
      <S.SecondHeadWrapper>
        <Typography variant="body2Bold">{`${t(translation.filteredWithText)}:`}</Typography>
        {globalFilters?.filters?.type?.map(filter => (
          <Badge
            color="bgWeak"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status,
                type: globalFilters.filters.type.filter(f => f.value !== filter.value),
                createdBy: globalFilters.filters.createdBy
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
        {globalFilters?.filters?.status?.map(filter => (
          <Badge
            color="bgWeak"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status.filter(f => f.value !== filter.value),
                type: globalFilters.filters.type,
                createdBy: globalFilters.filters.createdBy
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
        {globalFilters?.filters?.createdBy &&
          globalFilters?.filters?.createdBy?.map(filter => (
            <Badge
              color="bgWeak"
              variant="contained"
              key={filter.value}
              size="sm"
              rounded
              closable
              onClose={() => {
                onFilterChange({
                  status: globalFilters.filters.status,
                  type: globalFilters.filters.type,
                  createdBy: globalFilters.filters.createdBy.filter(f => f.value !== filter.value)
                });
              }}
            >
              {filter.label}
            </Badge>
          ))}
      </S.SecondHeadWrapper>
    )
  );
}

SecondHead.propTypes = {
  globalFilters: PropTypes.shape({
    filters: PropTypes.shape({
      source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      createdBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      type: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    })
  }),
  onFilterChange: PropTypes.func
};

export { SecondHead };
